import PropTypes from 'prop-types';

const Icon = ({ colour, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="35"
    height="37"
    viewBox="0 0 35 37"
    {...props}
  >
    <defs>
      <path
        id="password-a"
        d="M155.988 1243.37c-.36.891-.603 1.826-.72 2.78a15.338 15.338 0 00-7.207 13.073 15.544 15.544 0 004.53 10.912c2.78 2.78 6.69-.618 10.912-.618 4.22 0 8.132 3.397 10.911.618a15.544 15.544 0 004.53-10.912 14.823 14.823 0 00-2.677-8.647l2.368-.103a16.882 16.882 0 012.367 8.75 17.5 17.5 0 11-25.014-15.853zm7.515-2.676a6.28 6.28 0 015.44 3.177l.118.22-5.456-.309h-.205a3.912 3.912 0 00-3.799 3.609l-.01.2v.206a3.809 3.809 0 003.782 3.608l.232-.005 6.074-.412v10.294a6.176 6.176 0 01-12.349.226l-.004-.226v-14.412a6.176 6.176 0 016.177-6.176zm0 16.47a2.059 2.059 0 00-2.06 2.06c-.009.673.329 1.3.886 1.664l.144.085v1.338a1.03 1.03 0 002.053.113l.006-.113v-1.338a1.956 1.956 0 001.03-1.75 2.059 2.059 0 00-2.06-2.059zm-.279-11.53l.176.001h.103l11.529.72h.412l4.735.31c.45.09.786.468.823.926-.059.4-.327.735-.696.884l-.127.042h-2.78l-13.896.927a1.956 1.956 0 01-2.043-1.681l-.016-.172-.002-.175a1.853 1.853 0 011.61-1.768l.172-.015z"
      ></path>
    </defs>
    <use fill={colour} transform="translate(-146 -1240)" xlinkHref="#password-a"></use>
  </svg>
);

Icon.propTypes = {
  colour: PropTypes.string.isRequired,
};

export default Icon;
